import "./ContactUs.scss";
import HomeNavbar from "../../../components/homeNavbar/HomeNavbar";
import HomeFooter from "../../../components/homeFooter/HomeFooter";
import { Helmet } from "react-helmet-async";


const ContactUs = ({ active }) => {

    return (
        <div>
            <div className="homeContainer">
                <Helmet>
                    <title>TactiBots | Where Bussinesses Learn, Share & Grow</title>
                    <meta name="description" content="TactiBots is a FREE tool to monitor multiple e-commerce platform." />
                    <meta name="og:description" content="TactiBots is a FREE tool to monitor multiple e-commerce platform." />
                    <meta property="og:image" content="https://tactibot.com/static/media/logo_background.3e6fe6b035d735b3db9e.png" />
                </Helmet>
                <HomeNavbar active={active} />
                <div className="middle">
                    <div className="contactUsContainer" name="contactUsContainer">

                        <div className="topContainer">
                            <h1>Contact Us</h1>
                            <p>Feel free to approach us!</p>
                        </div>

                        <div className="location">
                            <div className="right">
                                <div className="details">
                                    <h1>Email</h1>
                                    <p>contact@tactibots.com</p>
                                </div>
                                <div className="details">
                                    <h1>Phone</h1>
                                    <p>011 5559 1242</p>
                                </div>
                                <div className="details">
                                    <h1>Facebook</h1>
                                    <a href="https://www.facebook.com/tactibot">https://www.facebook.com/tactibot</a>
                                    <br></br>
                                    <a href="https://www.facebook.com/tactibot">https://www.facebook.com/tactibots (Old)</a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <HomeFooter />
        </div>
    )
}

export default ContactUs;